import { useState } from "react";
import { Check, Minus, Layers, Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/leuteliaApi";

const euro = (n) => (n == null ? "su progetto" : `${n.toLocaleString("it-IT")} €/mese`);

export default function ConfrontoPacchetti({ catalog, settings, readOnly }) {
  const [sent, setSent] = useState(null);
  const cur = readOnly ? null : settings?.pacchetto?.key;
  if (!catalog?.length) return null;
  const servizi = catalog[0].servizi || [];
  const righe = [...servizi.filter((s) => !s.sempre), ...servizi.filter((s) => s.sempre)];
  const chiedi = async (p) => {
    const first = (p.servizi || []).find((s) => s.incluso && !s.sempre && !(catalog.find((c) => c.key === cur)?.modules || []).includes(s.id));
    try { await api.pacchettoUpgrade({ module: first?.id || p.key, message: `Richiesta pacchetto ${p.name} dalla tabella di confronto` }); setSent(p.key); toast.success(`Richiesta per ${p.name} inviata: vi ricontattiamo entro un giorno lavorativo.`); }
    catch (e) { toast.error(e.message || "Invio non riuscito"); }
  };
  return (
    <div className="bg-white rounded-xl border border-brand-gold/25 p-5 mb-6" data-testid="confronto-pacchetti">
      <div className="flex items-start gap-3"><Layers size={20} className="text-brand-gold mt-0.5" />
        <div><h3 className="font-serif text-[20px] text-brand-ink leading-none">I pacchetti LEUTELIA a confronto</h3>
          <p className="text-[12.5px] text-brand-ink/60 mt-1.5">{cur ? "Il vostro pacchetto attuale è evidenziato. " : ""}Ogni colonna comprende tutto ciò che c'è a sinistra.</p></div>
      </div>
      <div className="mt-5 overflow-x-auto">
        <table className="w-full min-w-[820px] text-[12.5px] border-separate border-spacing-0">
          <thead>
            <tr>
              <th className="text-left font-normal text-[11px] uppercase tracking-[0.18em] text-brand-ink/50 pb-3 pr-3 align-bottom">Servizio</th>
              {catalog.map((p) => (
                <th key={p.key} className={`pb-3 px-2 align-bottom text-center ${p.key === cur ? "bg-brand-gold/10 rounded-t-xl" : ""}`} data-testid={`confronto-col-${p.key}`}>
                  <div className="font-serif text-[15px] text-brand-green">{p.name}</div>
                  <div className="text-[11px] text-brand-ink/55">{p.tagline}</div>
                  <div className="mt-1 font-semibold text-brand-ink">{p.key === "collection" ? `da ${(p.collection?.price_from || 0).toLocaleString("it-IT")} €/hotel al mese` : euro(p.price)}</div>
                  <div className="text-[10.5px] text-brand-ink/55" data-testid={`confronto-scansioni-${p.key}`}>{p.key === "collection" ? "1-4 scansioni/mese per hotel" : `${p.scans} scansion${p.scans === 1 ? "e" : "i"}/mese`} · {p.pages} pagine</div>
                  {p.key === "collection" && <div className="text-[10.5px] text-brand-ink/55">gruppi da {p.collection?.min_hotels} a {p.collection?.max_hotels} hotel</div>}
                  {p.key === cur && <div className="mt-1 inline-block rounded-full bg-brand-green text-brand-cream text-[10px] px-2 py-0.5 uppercase tracking-wider">il vostro</div>}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {righe.map((s) => (
              <tr key={s.id} className="border-t border-brand-gold/15" data-testid={`confronto-riga-${s.id}`}>
                <td className="py-2.5 pr-3 border-t border-brand-gold/15">
                  <div className="font-semibold text-brand-ink">{s.label}</div>
                  <div className="text-[11.5px] text-brand-ink/60 leading-snug">{s.desc}</div>
                </td>
                {catalog.map((p) => {
                  const inc = (p.servizi || []).find((x) => x.id === s.id)?.incluso;
                  return <td key={p.key} className={`text-center border-t border-brand-gold/15 ${p.key === cur ? "bg-brand-gold/10" : ""}`}>{inc ? <Check size={16} className="inline text-brand-green" /> : <Minus size={14} className="inline text-brand-ink/25" />}</td>;
                })}
              </tr>
            ))}
            {!readOnly && <tr>
              <td className="pt-3" />
              {catalog.map((p) => (
                <td key={p.key} className={`pt-3 px-2 text-center ${p.key === cur ? "bg-brand-gold/10 rounded-b-xl" : ""}`}>
                  {p.key === cur ? <span className="text-[11px] text-brand-ink/55">Pacchetto attivo</span>
                    : catalog.findIndex((c) => c.key === p.key) < catalog.findIndex((c) => c.key === cur) ? null
                    : <button onClick={() => chiedi(p)} disabled={sent === p.key} className="inline-flex items-center gap-1.5 rounded-full border border-brand-green text-brand-green px-3 py-1.5 text-[11.5px] font-semibold hover:bg-brand-green hover:text-brand-cream transition-colors disabled:opacity-60" data-testid={`confronto-richiedi-${p.key}`}><Mail size={12} /> {sent === p.key ? "Richiesta inviata" : "Richiedi"}</button>}
                </td>
              ))}
            </tr>}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-[11.5px] text-brand-ink/55">Prezzi mensili IVA esclusa · durata contrattuale di riferimento 12 mesi · setup iniziale separato dal canone.</p>
    </div>
  );
}
